// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider-slide {\n  outline: none;\n  cursor: default; }\n", ""]);
// Exports
module.exports = exports;
